import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { getListHealthScore } from "happ-redux/happ-actions/indicadoresSalud/indicadoresSaludActions";
import Score from "react-score-indicator";
import './Indicadores.css';
import { makeStyles } from "@material-ui/core/styles";

//happ-icons 
import { IconIM, IconIndicators, IconHeart } from "happ-components/happ-icons/icons";

//happ-components
import ScoreResult from 'happ-components/Indicadores/ScoreResult';

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import stylesDash from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
const ProfileStyle = makeStyles(styles);  
const dashStyles = makeStyles(stylesDash);

const IndicadoresMedicos = () => {
    const dispatch = useDispatch();
    const ProfileClass = ProfileStyle();
    const DashClass = dashStyles();
    const [value, addValue] = useState(50);

    useEffect(() => {
        dispatch(getListHealthScore());
    }, []);
    const healthScore = useSelector(state => state.indicadores.health_score);
    const rcvPatient = useSelector(state => state.indicadores.rcvPatient);
    let backColor;
    if (rcvPatient !== null){
        if (rcvPatient === "Bajo") {
            backColor = 'warningRcv';
        }
        if (rcvPatient === "Moderado") {
            backColor = 'mediumRcv'
        }
        if (rcvPatient === "Alto") {
            backColor = 'dangerRcv'
        }
    }
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardHeader color="rose" icon>
                        <CardIcon className={`${ProfileClass.iconBack} content-icons`}>
                            <IconIM />
                        </CardIcon>
                        <h4 className={ProfileClass.cardIconTitle}>
                            Mis Indicadores de Salud
                        </h4>
                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12} lg={12}>
                            {rcvPatient ? (
                                <div className="div_box">
                                    {/* <Score
                                        value={value}
                                        maxValue={100}
                                        borderWidth={0}
                                        maxAngle={260}
                                        rotation={90}
                                        lineGap={0}
                                        lineWidth={50}
                                        colors={[
                                            "#d12000",
                                            "#ed8d00",
                                            "#f1bc00",
                                            "#84c42b",
                                            "#53b83a",
                                            "#3da940",
                                            "#3da940",
                                            "#3da940"
                                        ]}
                                    /> */}
                                    <CardIcon color={''} colorBack={backColor} className="icon-custom-test content-icons-grey rcv_div">
                                        <IconHeart />
                                    </CardIcon>
                                    <div className="info_rcv">
                                        <p>Usted tiene un Riesgo Cardiovascular {rcvPatient}</p>
                                    </div>
                                </div>
                            ) : null}
                            </GridItem> 
                            {healthScore ? (
                                healthScore.map(benefit => (
                                    <GridItem xs={6} sm={6} md={6} lg={3} key={benefit.healtBefenit.healthBenefitName}>
                                        <Card className="indication_card">
                                            <CardHeader color={benefit.determination.status ? benefit.determination.status : 'success'} stats icon>
                                            <CardIcon color={benefit.determination.status ? benefit.determination.status : 'success'} className="div_ico content-icons-indi">
                                                    <p className={`p_slogan ${benefit.determination.name === 'Saludable' ? 'p_slogan_hidden' : ''}`}>{benefit.determination.type}</p>
                                                <IconIndicators />
                                                    <p className="p_slogan">{benefit.determination.name}</p> 
                                            </CardIcon>
                                            <p className={`indication_title ${DashClass.cardCategory}`}>{benefit.healtBefenit.healthBenefitName === 'Perfil Lipídico' ? '': benefit.healtBefenit.healthBenefitName}</p>
                                            <h3 className={`indication_value ${DashClass.cardTitle}`}>
                                                <ScoreResult 
                                                    results={benefit.healtBefenit.results}
                                                />
                                            </h3>
                                            </CardHeader>
                                        </Card>
                                    </GridItem> 
                                ))
                            ) : (
                                <p>Cargando...</p>
                            )}  
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>    
        </GridContainer>
      );
}
 
export default IndicadoresMedicos;